import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HiddenInGlobaleModeDirective } from '@pages/checkout-app/directives/hidden-in-globale-mode.directive';
import { FlexModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '@app/sharedModule/shared.module';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletDrawModule } from '@bluehalo/ngx-leaflet-draw';
import { environment } from '@environment/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CheckoutLayoutComponent } from '@pages/checkout-app/checkout-layout/checkout-layout.component';
import { CheckoutContainerComponent } from '@pages/checkout-app/checkout-layout/main/components/checkout/checkout-container.component';
import { CheckoutAppComponent } from '@pages/checkout-app/checkout-layout/main/components/delivery-rates/checkout-form/checkout.app.component';
import { CheckoutListComponent } from '@pages/checkout-app/checkout-layout/main/components/delivery-rates/checkout-list/checkout-list';
import { DisplayConditionsComponent } from '@pages/checkout-app/checkout-layout/main/components/delivery-rates/checkout-list/components/conditions/display-conditions.component';
import { DisplayDeliveryDaysNTimesComponent } from '@pages/checkout-app/checkout-layout/main/components/delivery-rates/checkout-list/components/delivery-days-n-times/display-delivery-days-n-times.component';
import { DisplayDeliveryPromiseComponent } from '@pages/checkout-app/checkout-layout/main/components/delivery-rates/checkout-list/components/delivery-promise/display-delivery-promise.component';
import { FallbackOptionComponent } from '@pages/checkout-app/checkout-layout/main/components/delivery-rates/checkout-list/components/fallback-option/fallback-option.component';
import { DisplayGeoSettingsComponent } from '@pages/checkout-app/checkout-layout/main/components/delivery-rates/checkout-list/components/geo-settings/display-geo-settings.component';
import { RatePricesComponent } from '@pages/checkout-app/checkout-layout/main/components/delivery-rates/checkout-list/components/rate-prices/display-rate-prices.component';
import { ExtensionsModule } from '@pages/checkout-app/checkout-layout/main/components/extensions/extensions.module';
import { ExtensionGroupsModule } from '@pages/checkout-app/checkout-layout/main/components/extension-groups/extension-groups.module';
import { AbtestSettingsChangePercentDialogComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/abtest-settings/change-percent-dialog/abtest-settings-change-percent-dialog.component';
import { CheckoutScriptPreferences } from '@pages/checkout-app/checkout-layout/main/components/settings/components/checkout-script-preferences/checkout-script-preferences';
import { ConnectDeliveryCustomizationFunctionComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/connect-delivery-customization-function/connect-delivery-customization-function.component';
import { ScriptPreferencesDialogComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/dialogs/script-preferences-dialog.component';
import { OptimizationComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/optimization/optimization.component';
import { PluginsScriptPreferencesComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/plugins-script-preferences/plugins-script-preferences';
import { PricePreferencesComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/price-preferences/price-preferences';
import { ManageProcessTimeDialogComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/process-time/manage-process-time-dialog/manage-process-time-dialog.component';
import { ProcessTimeComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/process-time/process-time.component';
import { CheckoutPrioritizationComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/checkout-prioritization/checkout-prioritization.component';
import { AddDiscountComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/add-discount/add-discount.component';
import { TestModeComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/test-mode/test-mode.component';
import { SettingsComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/settings.component';
import { TrackingPageModule } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/tracking-page.module';
import { AbtestComponent } from '@pages/checkout-app/components/abtest/abtest.component';
import { AbtestDialogComponent } from '@pages/checkout-app/components/abtest/dialogs/abtest-dialog/abtest-dialog.component';
import { DisableABTestMenuAction } from '@pages/checkout-app/components/abtest/pipes';
import { FallbackOptionsDialog } from '@pages/checkout-app/components/dialogs/fallback-option/fallback-options.dialog';
import { ThirdPartyEnabledComponent } from '@pages/checkout-app/components/dialogs/third-party-enabled/third-party-enabled.component';
import { FeePerCartValueComponent } from '@pages/checkout-app/components/fee-per-cart-value/fee-per-cart-value.component';
import { FeePerWeekdayComponent } from '@pages/checkout-app/components/fee-per-weekday/fee-per-weekday.component';
import { DeliveryPromiseDeliveryTimeSettingsComponent } from '@pages/checkout-app/components/sections/delivery-promise/delivery-promise-deliverytime-settings/delivery-promise-deliverytime-settings.component';
import { DeliveryPromiseRestrictionsComponent } from '@pages/checkout-app/components/sections/delivery-promise/delivery-promise-restrictions/delivery-promise-restrictions.component';
import { NewRecommendedDelivery } from '@pages/checkout-app/components/sections/new-recommended-delivery/new-recommended-delivery';
import {
  ConvertDatePickerExtensionsToLinkedOptions,
  ConvertMultiShipProfilesToLinkedOptions,
  CountriesDropdownOptions,
  DisplayCategory,
  DisplayCondition,
  DisplayPreviewRunningABTestOnlyIfExists,
  DisplayRates,
  FeePerItemstepUnitOption,
  DropdownOptionOf,
  FeePerItemTypeOption,
  FilterLocationCondition,
  ProcessingTimeCheckAll,
  ProcessingTimeOptions,
  SortByLabelPipe,
  StatesDropdownOptions,
} from '@pages/checkout-app/shared/pipes/checkout.pipes';
import {
  DecreaseWeekDayOption,
  DeliveryPromiseInputTitlePipe,
  DisplayDDPAdditionalConfig,
  GEODeliveryAreaConfigFilter,
  PDQIQZoneDeliveryPromiseDays,
  ReplaceUnderscorePipe,
} from '@pages/checkout-app/utils/checkout.pipes';
import { StorybookModule } from '@storybook/storybook.module';
import { AbTestingContainerComponent } from './checkout-layout/main/components/ab-testing/ab-testing-container.component';

import { AbTestSettingsComponent } from './checkout-layout/main/components/settings/components/abtest-settings/abtest-settings.component';
import { CheckoutEffects } from './checkout-store/effects/checkout.effects';
import * as fromCheckout from './checkout-store/reducers/checkout.reducer';
import { CheckoutAppRoutingModule } from './checkout.app-routing.module';
import { ChooseABTestGroupComponent } from './components/abtest/abtest-groups/choose-abtest-group/choose-abtest-group.component';
import { AbTestV2MigrationDialog } from './components/abtest/dialogs/abtest-v2-migration-dialog/abtest-v2-migration-dialog.component';
import { CreateAbTestGroupDialogComponent } from './components/abtest/dialogs/create-abtest-group-dialog/create-ab-test-group-dialog.component';
import { DeleteDialog } from './components/dialogs/delete-dialog/delete-dialog';
import { ErrorDialog } from './components/dialogs/error-dialog/error-dialog';
import { PolygonFetchCitiesDialog } from './components/dialogs/polygon-fetch-cities-dialog/polygon-fetch-cities-dialog';
import { PolygonSuccessDialog } from './components/dialogs/polygon-success-dialog/polygon-success-dialog';
import { FeePerItemComponent } from './components/fee-per-item/fee-per-item.component';
import { ItemFeeRulesComponent } from './components/fee-per-item/item-fee-rules/item-fee-rules.component';
import { ItemFeeSetupBarComponent } from './components/fee-per-item/item-fee-setup-bar/item-fee-setup-bar.component';
import { ItemFeeSetupNameDialogComponent } from './components/fee-per-item/item-fee-setup-bar/item-fee-setup-name-dialog.component';
import { ItemFeePreviewComponent } from './components/fee-per-item/item-fee-preview/item-fee-preview.component';
import { AddCheckout } from './components/form-actions/add-checkout/add-checkout';
import { EditCheckout } from './components/form-actions/edit-checkout/edit-checkout';
import { Polygon } from './components/polygon/polygon';
import { BlackoutDatesComponent } from './components/sections/blackout-dates/blackout-dates.component';
import { ConditionComponent } from './components/sections/conditions/condition.component';
import { DaysNTimesComponent } from './components/sections/days-and-times/days-n-times.component';
import { DeliveryPromiseComponent } from './components/sections/delivery-promise/delivery-promise.component';
import { GeneralSettingsComponent } from './components/sections/general-settings/general-settings.component';
import { RecommendedDeliveryComponent } from './components/sections/recommended-delivery/recommended-delivery.component';
import { DragDropDirective } from './shared/directives/drag-drop.directive';
import { IframeDialogComponent } from '@app/sharedModule/dialogs/iframe-dialog/iframe-dialog.component';
import { ProductPromiseService } from '../engage/product-page/product-promise.service';
import { EngageModule } from '../engage/engage.module';
import { BulkEditConditionDialogComponent } from './components/dialogs/bulk-edit-condition-dialog/bulk-edit-condition-dialog.component';

const CONTAINERS = [
  CheckoutAppComponent,
  CheckoutListComponent,
  DragDropDirective,
  DeleteDialog,
  EditCheckout,
  Polygon,
  PolygonSuccessDialog,
  PolygonFetchCitiesDialog,
  AddCheckout,
  ConditionComponent,
  ErrorDialog,
  DaysNTimesComponent,
  BlackoutDatesComponent,
  DeliveryPromiseComponent,
  RecommendedDeliveryComponent,
  GeneralSettingsComponent,
  // MapSettingsComponent,
  // MapComponent
  FallbackOptionComponent,
  FallbackOptionsDialog,
  NewRecommendedDelivery,
  ReplaceUnderscorePipe,
  ProcessTimeComponent,
  ManageProcessTimeDialogComponent,
  ProcessingTimeOptions,
  AbtestComponent,
  AbtestDialogComponent,
  AbTestV2MigrationDialog,
  DeliveryPromiseInputTitlePipe,
  CheckoutLayoutComponent,
  ThirdPartyEnabledComponent,
  SettingsComponent,
  OptimizationComponent,
  AbTestSettingsComponent,
  TestModeComponent,
  CountriesDropdownOptions,
  StatesDropdownOptions,
  SortByLabelPipe,
  ProcessingTimeCheckAll,
  DisplayRates,
  DisplayCategory,
  FilterLocationCondition,
  DisplayCondition,
  DisplayConditionsComponent,
  FeePerItemComponent,
  ItemFeeRulesComponent,
  ItemFeeSetupBarComponent,
  ItemFeeSetupNameDialogComponent,
  ItemFeePreviewComponent,
  FeePerItemstepUnitOption,
  DropdownOptionOf,
  FeePerItemTypeOption,
  CheckoutScriptPreferences,
  AbtestSettingsChangePercentDialogComponent,
  DisableABTestMenuAction,
  FeePerWeekdayComponent,
  DecreaseWeekDayOption,
  FeePerCartValueComponent,
  ChooseABTestGroupComponent,
  CreateAbTestGroupDialogComponent,
  RatePricesComponent,
  DisplayDeliveryPromiseComponent,
  DisplayDeliveryDaysNTimesComponent,
  DisplayGeoSettingsComponent,
  DisplayPreviewRunningABTestOnlyIfExists,
  CheckoutContainerComponent,
  AbTestingContainerComponent,
  ConnectDeliveryCustomizationFunctionComponent,
  PricePreferencesComponent,
  PluginsScriptPreferencesComponent,
  ScriptPreferencesDialogComponent,
  ConvertDatePickerExtensionsToLinkedOptions,
  ConvertMultiShipProfilesToLinkedOptions,
  PDQIQZoneDeliveryPromiseDays,
  GEODeliveryAreaConfigFilter,
  DeliveryPromiseRestrictionsComponent,
  DisplayDDPAdditionalConfig,
  DeliveryPromiseDeliveryTimeSettingsComponent,
  IframeDialogComponent,
  CheckoutPrioritizationComponent,
  BulkEditConditionDialogComponent,
  AddDiscountComponent,
  HiddenInGlobaleModeDirective,
];

@NgModule({
  declarations: [...CONTAINERS],
  providers: [{ provide: ProductPromiseService }],
  imports: [
    DragDropModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    CommonModule,
    MatSelectModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDividerModule,
    MatSlideToggleModule,
    CheckoutAppRoutingModule,
    StoreModule.forFeature(fromCheckout.featureKey, fromCheckout.reducer),
    EffectsModule.forFeature([CheckoutEffects]),
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatTooltipModule,
    LeafletModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    ClipboardModule,
    LeafletDrawModule,
    LeafletModule,
    FlexModule,
    MatGoogleMapsAutocompleteModule.forRoot(environment.GOOGLE_API_KEY),
    ScrollingModule,
    SharedModule,
    StorybookModule,
    TrackingPageModule,
    ExtensionsModule,
    ExtensionGroupsModule,
    EngageModule,
  ],
})
export class CheckoutAppModule {}
